import { Schema } from "@effect/schema";
import { Address, Amount, ChainKey, ProtocolKey, Usd } from "@silo/types";
import { UserMerklReward } from "../merkl-client/types";

export type NativeRewards = typeof NativeRewards.Type;
export type NativeRewardsEncoded = typeof NativeRewards.Encoded;

export const NativeRewards = Schema.Struct({
  rewardTokenAddress: Address,
  rewardTokenSymbol: Schema.String,
  rewardTokenDecimals: Schema.Number,
  balance: Amount,
  balanceUsd: Usd,
}).annotations({ identifier: "NativeRewards" });

export type MerklRewards = typeof MerklRewards.Type;
export type MerklRewardsEncoded = typeof MerklRewards.Encoded;

export const MerklRewards = Schema.Struct({
  totalUsd: Usd,
  rewards: Schema.Array(UserMerklReward),
}).annotations({ identifier: "MerklRewards" });

export type RewardsData = typeof RewardsData.Type;
export type RewardsDataEncoded = typeof RewardsData.Encoded;

export const RewardsData = Schema.Struct({
  data: Schema.Struct({
    protocolKey: ProtocolKey,
    chainKey: ChainKey,
    user: Address,
    totalRewardsUsd: Usd,
    nativeRewards: Schema.NullOr(NativeRewards),
    merklRewards: Schema.NullOr(MerklRewards),
  }),
}).annotations({ identifier: "RewardsData" });
